module.exports = __webpack_public_path__ + "04bb46d4b5846c9db2fc85c8384502a5.pdf";